<template>

    <footer class="bg-light">

        <div v-if="dialogTermo">
            <b-modal size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogTermo" :hide-footer="true" title="Termo de uso">
                <form>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div class="col-xs-9">
                                <div style="border: 1px solid #e5e5e5; height: 300px; overflow: auto; padding: 10px;">
                                    <span v-html="termoUso.texto"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<p>
                        <input type="checkbox" value="aceito" @click="aceito = !aceito" required />&nbsp;
                        {{termoUso.textoAcordo}}
                    </p>
                    <button type="button" class="btn btn-success float-right" @click="confirmTermodeUso(termoUso)">
                        <span>Confirmar</span>
                    </button>-->
                    <div style="float:right;">
                        <button type="button" class="btn btn-outline-danger float-left" @click="dialogTermo = false">
                            <span>Fechar</span>
                        </button>
                    </div>
                    
                </form>
            </b-modal>
        </div>


        <div class="container">
            <div class="row">
                <div class="col-lg-5">

                    <ul class="menu-rodape">
                        <li><a href="#" @click="startTutorial()">Manual</a> </li>
                        <li><a href="#" @click="getTermoUso()">Termos e Condições</a> </li>
                        <li>
                            <p style="font-size: 13px;">
                                O CNA respeita a sua privacidade e <br>
                                protege seus dados pessoais de acordo <br>
                                com a <a href="https://cna.com.br/politica-de-privacidade" target="_blank">Política de Privacidade</a>
                            </p>
                        </li>
                    </ul>

                </div>
                <div class="col-lg-7 text-center py-4"  v-if="!cnaStore">
                    <img src="../assets/images/logo-branco.png" width="150" class="img-fluid" alt="logo CNA"><br>
                    <span class="text-white"> {{conteudoSite[0]}} | {{conteudoSite[1]}}</span><br>
                    <span class="text-white"> {{conteudoSite[2]}}</span><br>
                    <span class="text-white" v-if="!cnaStore"> {{conteudoSite[3]}} | <a v-bind:href="'mailto:'+conteudoSite[4]" class="text-white">{{conteudoSite[4]}}</a> </span><br>                    
                    <span class="text-white"> Shopping CNA {{ getYear() }}</span>
                </div>
                <div class="col-lg-7 text-center py-4"  v-if="cnaStore">
                    <img src="../assets/images/logo-branco.png" width="150" class="img-fluid" alt="logo CNA"><br>
                    <span class="text-white"> {{conteudoSite[0]}} | {{conteudoSite[1]}}</span><br>
                    <span class="text-white"> {{conteudoSite[2]}}</span><br>                    
                    <span class="text-white"> {{conteudoSite[5]}} | <a v-bind:href="'mailto:'+conteudoSite[6]" class="text-white">{{conteudoSite[6]}}</a> </span><br>
                    <span class="text-white"> Shopping CNA {{ getYear() }}</span>
                </div>
            </div>
        </div>
    </footer>

</template>
<script>
    import Vue from 'vue'    
    import { Api } from '@/common/api'
    import Global from '@/common/global'
    import tutorStep from '@/common/tutor-step'
    import Cache from '@/common/cache'
    import Auth from '@/common/auth'

    export default {
        name: "footer-cna",
        data() {
            return {
                changelog: null,
                dialogChangeLog: false,
                dialogTermo: false,
                aceito: false,
                termoUso: {},
                conteudoSite: [],
                cnaStore: false,
                filter: {                    
                    chave: "CONTEUDO_RODAPE",
                    ativo: true,
                    attributeBehavior:"GetConteudoSite"
                },
            };
        },
        methods: {
            getYear() {
                return new Date().getFullYear();
            },
            getTermoUso: function () {
                this.dialogTermo = false;
                new Api("termouso/GetUltimoTermo").get({ attributeBehavior: "GetUltimoTermoUsoExibicao" }).then(data => {
                    setTimeout(() => {
                        if (data.data) {
                            this.termoUso = data.data;
                            this.dialogTermo = true;
                        } else {
                            this.dialogTermo = false
                        }
                    }, 1000);

                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            getConteudoSite: function () {                
                new Api("conteudosite").get(this.filter).then(data => {  
                    setTimeout(() => {
                        this.conteudoSite = data.dataList; 
                    }, 1000);                                              
                    //console.log("conteudo site", data);                        
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            
            startTutorial() {
                
                Cache.remove("TUTOR_HOME");
                this.$eventHub.$emit('start-tutorial');
            },
        },
        mounted() {

            this.cnaStore = Cache.get(Auth.ehCnaStore_key) == 'true' ? true : false;            

            this.getConteudoSite();
        }

    };
</script>